// extracted by mini-css-extract-plugin
export default {"tudo":"meio_tudo__+CpDR"};